import React, { useState } from "react";
import { Button, Col, Form, Input, Row } from "antd";
import CommentBox from "../../../components/commentBox";
import TaskCheckedList from "../../../components/taskCheckedList";
import PageHeader from "../../../components/pageHeader";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

function PlaceCodebox({ itemId, listId, alreadyCheckedItems }) {
  const isItemChecked = alreadyCheckedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  function handleUndefinedValues(obj) {
    const newObj = {};
    for (let key in obj) {
      newObj[key] = obj[key] === undefined ? "" : obj[key];
    }
    return newObj;
  }
  const onFinish = async (values) => {
    console.log("Success:", values);
    values = handleUndefinedValues(values);
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
              details: item.id == itemId && values,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div className="item-page">
      <Form
        className="item-page-container"
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="Place codebox" />
          </Col>
          <Col span={24}>
            <h1 className="blue-heading">
              By clicking this box you will create a task for Gina to place a
              codebox. if you plan to place yourself do not click, but please!
              do the items below!
            </h1>
          </Col>
          <Col span={24}>
            <p>
              go to this property and place a codebox and remove the lockbox.
            </p>
          </Col>
          <Col span={24}>
            <p>
              record the codebox number below for the PM also be sure to update
              the "Manage Physical Lockbox" page in appfolio
            </p>
          </Col>
          <Col span={24}>
            <p>
              ALSO BE SURE TO TAKE A PICTURE OF THE CODEBOX IN THE INSPECTION
              COMPLETED
            </p>
          </Col>
          <Col span={24}>
            <p>also make sure and place a sign</p>
          </Col>
          <Col span={24}>
            <p>
              If there is not a listing inspection from less than 2 weeks ago do
              a new one
            </p>
          </Col>
          <Col span={24}>
            <Form.Item label="codebox number" name="codeboxNumber">
              <Input placeholder="Type answer here" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary" htmlType="submit" disabled={isDisabled}>
                  Completed
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default PlaceCodebox;
